module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_add-4b404137617e2c1d2492af61037a3ca8.svg";